var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-10 fill-height"},[_c('div',{staticClass:"windowArea"},[_c('PackagesSection')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }